import { Component, Input } from '@angular/core';
import { DataService } from '../../../core/data.service';
import { SessionService } from '../../../core/session.service';

@Component({
  standalone: false,
  selector: 'app-product-price',
  template: `
    @switch (status) {
      @case ('exists') {
        <span class="price">{{ product.price | currency }}</span>
      }
      @case ('requested') {
        <span class="requested">Requested</span>
      }
      @case ('denied') {
        <span class="denied">Denied</span>
      }
      @default {
        <button class="request-btn" (click)="requestPrice()" [disabled]="requesting">
          {{ requesting ? '...' : 'Request Price' }}
        </button>
      }
    }
  `,
  styles: [`
    .price { font-weight: 600; color: #333; }
    .requested { color: #f0ad4e; font-size: 12px; }
    .denied { color: #d9534f; font-size: 12px; }
    .request-btn {
      background: none;
      border: 1px solid var(--brand-primary);
      color: var(--brand-primary);
      padding: 2px 8px;
      border-radius: 3px;
      cursor: pointer;
      font-size: 11px;
    }
    .request-btn:hover { background: var(--brand-primary); color: #fff; }
    .request-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  `]
})
export class ProductPriceComponent {
  @Input() product: any;
  requesting = false;

  constructor(private dataSvc: DataService, private session: SessionService) {}

  get status(): string {
    if (this.product?.price === -1) return 'denied';
    if (this.product?.price > 0) return 'exists';

    // Check if price request already submitted
    const requests = this.session.data['mdPriceRequests'] || [];
    const found = requests.find((r: any) => r.part_nr === this.product?.part_nr);
    if (found) return 'requested';

    // No price and availability is "Call" with no cycle code A/B
    const avail = this.product?.avail || '';
    const cycle = this.product?.cycle_code || '';
    if (avail === 'Call' && !['A', 'B'].includes(cycle)) return 'missing';

    if (!this.product?.price) return 'missing';
    return 'exists';
  }

  requestPrice(): void {
    if (this.requesting) return;
    this.requesting = true;
    this.dataSvc.dgGet([{
      action: 'PriceRequest',
      returnas: '',
      sku: this.product.part_nr
    }]).subscribe({
      next: () => {
        this.session.loadPriceRequests();
        this.requesting = false;
      },
      error: () => { this.requesting = false; }
    });
  }
}
